export DsfNavTree from "./navTree.vue";
// export DsfCheckNode from "./checkNode";

export const DsfTree = dsf.defineAsyncComponent("DsfTree", () =>
  import(/* webpackChunkName: "platform_pc_tree_module" */ "./tree.vue")
);
export const DsfTreeSelector = dsf.defineAsyncComponent("DsfTreeSelector", () =>
  import(/* webpackChunkName: "platform_pc_tree_module" */ "./treeSelector.vue")
);
export const DsfCustomDropTreeLogicNode = dsf.defineAsyncComponent(
  "DsfCustomDropTreeLogicNode",
  () => import(/* webpackChunkName: "platform_pc_tree_module" */ "./drop/template/logicNode.js")
);

export const DsfCheckNode = dsf.defineAsyncComponent("DsfCheckNode", () => {
  //DsfCheckNode组件依赖于DsfTreeSelector，而DsfTreeSelector又是一个异步组件
  return dsf.requestAsyncComponents(DsfTreeSelector).then(() => {
    return import(/*webpackChunkName:"platform_pc_tree_module"*/ "./checkNode");
  });
});

export const DsfTreeInfo = dsf.defineLazyComponent("DsfTreeInfo", () => require("./treeInfo.vue"));
export const DsfCustomDropTree = dsf.defineLazyComponent("DsfCustomDropTree", () =>
  require("./drop/customDropTree")
);
